// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// NOTE: Web client config only (do NOT include service account keys in client)
const firebaseConfig = {
  apiKey: "AIzaSyBsuLKrqSV8Owz7Fws44WwoAtwmAYC3328",
  authDomain: "area-services.firebaseapp.com",
  databaseURL: "https://area-services-default-rtdb.firebaseio.com",
  projectId: "area-services",
  storageBucket: "area-services.firebasestorage.app",
  messagingSenderId: "27121568618",
  appId: "1:27121568618:web:541e6811cc56510edb7313",
  measurementId: "G-5LK6L0KBHH"
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export { app, database };
